import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeMontant } from '../models/TypeMontant';

@Component({
  selector: 'app-type-montant',
  templateUrl: './type-montant.component.html'
})
export class TypeMontantComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeMontant';
  @Input() parentForm: FormGroup;
  @Input() typeMontant: TypeMontant;

  constructor() {
  }

  public ngOnInit() {
  }

  public getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}
